import { get } from '@/utils/client';

//types
import type { UploadedMediaType } from '@/utils/uploadMedia/uploadHelpers/types/UploadedMediaType';

import { MEDIA_STATUS } from '@/lib/routes/apiEndpoints';

const POLLING_INTERVAL_MS = 1500;
const MAX_POLLING_DURATION_MS = 5 * 60 * 1000;

type GetUploadedMediaType = {
    media_id: string;
    cancelToken?: AbortController;
};
export async function getUploadedMedia({
    media_id,
    cancelToken
}: GetUploadedMediaType): Promise<UploadedMediaType> {
    return new Promise((resolve, reject) => {
        const startTime = Date.now();

        async function getImage() {
            try {
                if (Date.now() - startTime > MAX_POLLING_DURATION_MS) {
                    return reject(new Error('errors:error_media_transcode_timeout'));
                }

                const uploadedMedia = await get<{ data: UploadedMediaType }>(
                    `${MEDIA_STATUS}/${media_id}`,
                    undefined,
                    { signal: cancelToken?.signal }
                );

                if (!uploadedMedia) {
                    return;
                }

                if (uploadedMedia.data.status === 'failed') {
                    return reject(new Error('errors:error_occured_submit_data'));
                }

                if (uploadedMedia.data.status === 'finished') {
                    const failedChild = uploadedMedia.data.children?.find(
                        (child) =>
                            child.status === 'failed' &&
                            child.data.error === 'error_media_transcode_timeout'
                    );
                    if (failedChild) {
                        return reject(new Error('errors:error_media_transcode_timeout'));
                    }

                    return resolve(uploadedMedia.data);
                }

                return setTimeout(() => getImage(), POLLING_INTERVAL_MS);
            } catch (error) {
                reject(new Error(`errors:error_occured_submit_data: ${error}`));
            }
        }
        getImage();
    });
}
